<script lang="ts">
  import { getNewsletterStores } from "../../newsletterStores";
  import type { LinkTypes } from "../../newsletterStores";
  import type { schema } from "@editor/schema";
  import { coerceUri, getBlockId, trackingAndAttributesFromCTA } from "../utils";

  export let cta: schema.CallToAction | undefined = undefined;
  export let type: LinkTypes = "link";
  export let linkText: string = "";
  export let showEmpty: boolean = false;
  export let skipFocusable: boolean = false;

  let hostname: string | undefined;
  const { ctx } = getNewsletterStores();
  const blockId = getBlockId();

  $: [target, hrefAttrs] = trackingAndAttributesFromCTA(ctx, cta, { type, text: linkText, blockId });
  if (cta) {
    try {
      hostname = new URL(coerceUri(cta.url)).hostname;
    } catch {
      hostname = undefined;
    }
  }

  // We would like to ensure that `aria-label` and `focusable` class have values
  // Therefore, we are cloning the reset of the props
  const allOtherAttributes = { ...$$restProps };
  const ariaLabelAttribute = allOtherAttributes["aria-label"];
  delete allOtherAttributes["aria-label"];
  const ariaLabel = ariaLabelAttribute || hostname || "Open link";

  // Ensure we have the `focusable` class unless the user has specified to skip it
  const classes = (allOtherAttributes["class"] || "").split(" ");
  if (!skipFocusable && !classes.includes("focusable")) {
    classes.push("focusable");
  }
  delete allOtherAttributes["class"];
</script>

{#if target || showEmpty}
  <!-- svelte-ignore a11y-missing-attribute-->
  <a
    target="_blank"
    class={classes.join(" ")}
    class:skip-tracking={/* skip-classic-tracking */ true}
    aria-label={ariaLabel}
    {...allOtherAttributes}
    {...hrefAttrs}>
    <slot href={target || "#"} isLink={true} />
  </a>
{:else}
  <slot isLink={false} />
{/if}
